import { render, staticRenderFns } from "./ElementWrapper.vue?vue&type=template&id=f42a4f50&scoped=true&"
import script from "./ElementWrapper.vue?vue&type=script&lang=js&"
export * from "./ElementWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ElementWrapper.vue?vue&type=style&index=0&id=f42a4f50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42a4f50",
  null
  
)

export default component.exports